import { useState, useEffect } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Box, Tooltip, IconButton, InputBase } from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseModel } from "./UseModel";
import { useNavigate, useLocation } from "react-router-dom";
import { UseMyPC } from "../../hooks/UseMyPC";
import CustomPagination from "../../components/CustomPagination";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { deCapitalizeFirstLetter } from "../../util/Utils";
import DeleteRow from "../../components/DeleteRow";
import { rsGotoLast, rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";

function Model() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const navigate = useNavigate();
  const { getModelList, deleteModel } = UseModel();
  const {
    myPc,
    goToLastPage,
    goToFirstPage,
    updatePage,
    updateSort,
    setScrollTo,
    refresh,
  } = UseMyPC();
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [searchState, setSearchState] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [search, setSearch] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [modelRes, setModelRes] = useState();
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });

  function handleSearch(value) {
    setScrollTo(undefined);
    location.state = null;
    setSearch(value);
  }

  useEffect(() => {
    if (
      myPc.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }
    setProgress(true);
    getModelList(
      myPc,
      search,
      (models) => {
        if (msGotoLast) {
          setMsGotoLast(false);
          goToLastPage(models.pageCondition.totalPage);
          return;
        }
        setModelRes(models);
      },
      true
    );
  }, [myPc]);

  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
    }
    if (search.length > 0 && !location.state) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [search]);

  const newFunc = () => {
    return navigate("/models/addmodel", {
      state: {
        myPc: myPc,
        search: search,
      },
    });
  };

  const columns = [
    {
      field: "id",
      width: 100,
      align: "center",
      headerName: "id",
      headerAlign: "center",
    },
    {
      field: "faName",
      headerName: "نام فارسی",
      width: 200,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "enName",
      headerName: "نام لاتین",
      width: 200,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "عملیات",
      sortable: false,
      width: 100,
      headerAlign: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <Box>
            <Tooltip title="Delete">
              <IconButton
                onClick={() => {
                  setDeleteState({
                    show: true,
                    name: cellValues.row.faName,
                    id: cellValues.row.id,
                  });
                }}
              >
                <DeleteIcon sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Edit">
              <IconButton
                onClick={() => {
                  setScrollTo(cellValues.api.getScrollPosition());

                  return navigate("/models/editmodel", {
                    state: {
                      model: cellValues.row,
                      myPc: myPc,
                      search: search,
                      id: cellValues.row.id,
                    },
                  });
                }}
              >
                <EditIcon sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },
    {
      field: "search",
      width: 200,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <Box
            sx={{ border: "1px solid #d3d3d3", borderRadius: 1 }}
            width="auto"
            display="flex"
            justifyContent="flex-start"
          >
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="جستجو"
              value={searchState}
              inputProps={{ "aria-label": "search" }}
              onChange={(evt) => {
                if (evt.target.value == "") {
                  handleSearch("");
                }
                setSearchState(evt.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch(searchState);
                }
              }}
            />
          </Box>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "اطلاعات پایه",
        childs: [{ name: msActiveMenu.pageTitle, url: "/models" }],
      }}
    >
      {modelRes ? (
        <DataGrid
          className="ltr-grid"
          disableVirtualization
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          pageSize={modelRes.pageCondition.pageCount}
          rows={modelRes.models}
          paginationMode="server"
          page={modelRes.pageCondition.page - 1}
          onPageChange={(page) => {
            updatePage(page + 1);
          }}
          rowCount={modelRes.pageCondition.totalItemCount}
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: {
              scrollTo: myPc.scrollTo,
              newFunc: newFunc,
              rowCount: modelRes.pageCondition.totalItemCount,
              isLtr: true,
            },
          }}
          initialState={{
            sorting: {
              sortModel: [
                {
                  field: deCapitalizeFirstLetter(myPc.sortColumn),
                  sort: deCapitalizeFirstLetter(myPc.sortOrder),
                },
              ],
            },
            pagination: {
              page: myPc.page,
            },
          }}
          onSortModelChange={(model) => {
            updateSort(model[0].field, model[0].sort == "asc" ? "asc" : "desc");
          }}
          sortingOrder={["desc", "asc"]}
          sortingMode="server"
        />
      ) : (
        <ProgressCom></ProgressCom>
      )}
      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={"مدل"}
        callback={() => {
          setProgress(true);
          deleteModel(deleteState.id, () => {
            refresh();
          });
        }}
      ></DeleteRow>
    </Detail>
  );
}

export default Model;
